'use strict';

const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('simple-square-example', function () {
    let sideLength = this.width - this.pad * 2;

    let shape = new Shape(4, sideLength, new Point(this.pad + sideLength, this.pad + sideLength));
    shape.dotSize = 1;
    shape.dumbSquare = true;

    shape.draw(this.ctx);
    shape.numberPoints(this.ctx);

    this.addToolbar(shape);
});


